"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Container(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "container",
    style: {
      backgroundColor: "#ffffff",
      minWidth: "250px",
      maxWidth: "375px",
      paddingBottom: "30px"
    }
  }, children);
}

var _default = Container;
exports["default"] = _default;